// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 4023) return "static/css/4023.8151e7327b4e75235228.css";
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + "83971b4df2c901ec0bdb" + ".chunk.css";
};